import { isMobileWebApp } from '@common/config/env'
import { getUiType } from '@web/utils/uiType'

/**
 * Whether this surface signs the DCA's `calls` requests in SignAccountOpOverlay,
 * an in-tree layer over the current screen that every portalled sheet paints
 * above. True on mobile-web and in the extension's browser-action popup (the
 * background keeps the wallet's own requests inside an open popup, see
 * `shouldSignInsidePopup` in background.ts). The extension's full-page tab signs
 * in its own request window, so its sheets can stay up.
 *
 * A DCA sheet must step aside while a request waits there: the overlay only
 * dismisses the sheets open when it appears, so one opened or reopened during
 * the signature covers the sign screen (Trello #599), and one left closed after
 * it leaves the form on screen between steps (Trello #600).
 */
export const SIGNS_IN_OVERLAY = isMobileWebApp || getUiType().isPopup
